<template lang="pug">
a.btn.btn-block.btn-auth-login(:href="oauthPath" id="googleRegisterLink" )
  img.icon-google(alt="google" src="/img/icon/google.png")
  | {{ text }}
</template>

<script>
import Vue from 'vue'

export default {
  props: {
    text: {type: String, default: "利用規約に同意してGoogleアカウントで新規登録"},
    params: {type: String, default: ""},
  },
  computed: {
    oauthPath() {
      // 言語変更を行った場合
      var language_param = null;
      var get_language = sessionStorage.getItem('language');
      if (get_language) {
        language_param = '&language='+get_language;
      }
      if (this.$store.state.user.plan_to_change.id) {
        return '/users/auth/google_oauth2?' + this.params + '&plan_id=' + this.$store.state.user.plan_to_change.id + '&coupon_code=' + this.$store.state.user.coupon_code + language_param;
      } else {
        return '/users/auth/google_oauth2?' + this.params + language_param;
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.btn-auth-login {
  background-color: #ffffff;
  border-radius: 20px;
}

.icon-google {
  background-color: #ffffff;
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
  width: 30px;
  height: 30px;
}
</style>
